module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/hospital01-35af619cbe4b1c777d9feb1fd36f521c.png";